<template>
  <div
    class="title"
    :style="{
      'padding-top': facade.margin + 'px',
      'padding-bottom': facade.margin + 'px',
      backgroundColor: facade.background_color
    }"
  >
    <div class="title-style1" v-if="content.style == 1" :style="{ color: facade.title_color }">
      <div class="title-content">{{ content.title }}</div>
    </div>

    <div class="title-style2" v-if="content.style == 2" :style="{ color: facade.title_color }">
      <div class="title-content">{{ content.title }}</div>
      <div class="title-decorate">◇</div>
    </div>

    <div class="title-style3" style="position: relative;" v-if="content.style == 3" @click="goDetail(content)">
      <div class="title-content" :style="{ color: facade.title_color, 'font-size': facade.title_font_size + 'px' }">{{ content.title }}</div>
      <div class="title-more" :style="{ color: facade.more_color }" v-if="content.is_more">
        {{ content.moretitle }} <van-icon name="arrow" />
      </div>
      <div class="title-subtitle" :style="{ color: facade.subtitle_color, 'font-size': facade.subtitle_font_size + 'px' }">{{ content.subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  methods: {
    goDetail(item) {
      console.log('标题：', item)
      if (item && item.is_more && item.link && item.link.jumpType !== 'share' && item.link.jumpType !== 'contact') {
        this.$emit('go-next', item.link)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  background: #ffffff;

  .title-style1,
  .title-style2,
  .title-style3 {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    position: relative;
  }

  .title-style3 {
    .title-content {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }

    .title-more {
      position: absolute;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      right: 16px;
      top: 0;
      height: 100%;
      line-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .title-subtitle {
      margin-top: 4px;
      font-size: 12px;
      height: 20px;
      font-weight: 400;
      color: #333333;
    }
  }

  .title-style1 {
    text-align: center;

    .title-content:before {
      display: inline-block;
      content: '';
      width: 15%;
      height: 5px;
      border-top: 1px solid #898989;
      margin-right: 10px;
    }

    .title-content:after {
      display: inline-block;
      content: '';
      width: 15%;
      height: 5px;
      border-top: 1px solid #898989;
      margin-left: 10px;
    }
  }

  .title-style2 {
    width: 85%;
    box-sizing: border-box;
    text-align: center;
    line-height: 20px;
    position: relative;
    margin: 0 auto;

    .title-content {
      font-weight: 400;
    }

    .title-decorate:before {
      position: absolute;
      content: '';
      width: 45%;
      border-bottom: 1px solid #898989;
      right: 0;
      top: 30px;
    }

    .title-decorate:after {
      position: absolute;
      content: '';
      width: 45%;
      border-bottom: 1px solid #898989;
      left: 0;
      top: 30px;
    }
  }
}
</style>